import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './lib/store';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import PaymentPage from './pages/PaymentPage';
import DashboardPage from './pages/DashboardPage';
import ProcessingPage from './pages/ProcessingPage';
import ClipsPage from './pages/ClipsPage';
import ApprovalPage from './pages/ApprovalPage';
import AdminDashboard from './pages/AdminDashboard';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

function App() {
  const { isAuthenticated, user } = useAuthStore();

  // Public routes (no auth required)
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // Authenticated routes
  return (
    <Routes>
      <Route path="/" element={<DashboardPage />} />
      <Route path="/process" element={<ProcessingPage />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/clips" element={<ClipsPage />} />
      <Route path="/approval/:clipId" element={<ApprovalPage />} />
      
      {/* Admin only */}
      {user?.role === 'admin' && (
        <Route path="/admin" element={<AdminDashboard />} />
      )}
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
